import { i18n } from "@/plugins/vuetify";
import { BillingCatalog, NO_PRICE_CLASS_CATALOG_ID } from "@/data/models/BillingCatalog";

/**
 * The name to show for a billing catalog.
 *
 * `catalogName` is imported data, not an i18n string, so it is normally rendered as it
 * stands: "LVM", "Aqua (STLV)". The one exception is the catalog that holds items with no
 * price class. That is not an LV and has no owner, so the import writes a technical
 * English placeholder there, which would otherwise appear untranslated in every locale.
 *
 * Use this anywhere a catalog is named to the user, so the placeholder never leaks.
 */
export function getBillingCatalogDisplayName(
  catalog: Pick<BillingCatalog, "id" | "catalogName">
): string {
  if (catalog.id === NO_PRICE_CLASS_CATALOG_ID) {
    return i18n.t("settings.billingCatalogs.noPriceClassName").toString();
  }
  return catalog.catalogName ?? "";
}
